import { useMutation } from '@tanstack/react-query';
import Toaster from 'src/app/utilities/helpers/Toaster';
import { parseErrors } from 'src/app/utilities/helpers/errors';
import ticketLinkImportService from 'src/data/services/ticketLinkImportService';

export interface CreateTicketLinkImportProps {
    bookingOptionId: string;
    file: File;
}

export const useCreateTicketLinkImport = (onSuccess?: () => void) => {
    return useMutation({
        mutationFn: (props: CreateTicketLinkImportProps) =>
            ticketLinkImportService.createTicketLinkImport(props.bookingOptionId, props.file),
        onSuccess: () => {
            Toaster.toast('Ticket link import created successfully', { variant: 'success' });
            onSuccess?.();
        },
        onError: (errors) => Toaster.toastErrors(parseErrors(errors)),
    });
};
